<template>
  <div id="footer">
    <footer>
      <div id="bigBox">
        <div class="footerBox">
          <div class="footerLeft">
            <div class="footer_logo">
              <img src="../assets/img/navLogo.png" alt="" />
              <span>|</span>
              <p>AI赋能千行百业</p>
            </div>
            <p>地址：河南省济源市沁园街道凯旋城C区1-18号</p>
            <p>联系电话：19603903563</p>
            <p>
              <a href="https://beian.miit.gov.cn/" target="_blank"
                >xxxxxxxxxxx</a
              >
              |
              <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802034904"
              >
                xxxxxxxxxxxxxxxxxxxxxx</a
              >
              | xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
            </p>
            <p>
              Copyright © 2016-2023 河南润信智能科技
              <a href="./html/license.html" target="_blank">营业执照</a>
            </p>
          </div>
          <div class="footerRight">
            <div>
              <img src="../assets/img/companyWx.png" alt="河南润信微信" />
              <p>河南润信微信</p>
            </div>
            <div>
              <img src="../assets/img/companyWx.png" alt="河南润信公众号" />
              <p>河南润信公众号</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
footer {
  background: #000;
  padding: 3.5rem 0;
}
.footerBox {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.footerLeft {
  text-align: left;
}
.footer_logo {
  display: flex;
  align-items: center;
}
.footer_logo img {
  width: 100px;
}
.footer_logo span {
  margin: 0 10px;
  font-size: 1.25rem;
  margin: 0 20px 8px;
}
.footer_logo > p {
  font-size: 1.25rem !important;
  font-weight: 400 !important;
  color: #fff !important;
  opacity: 1 !important;
  margin-bottom: 6px;
}
.footerLeft > p:nth-child(4) {
  display: flex;
}
.footerLeft > p:nth-child(4) > a,
.footerLeft > p:nth-child(5) > a {
  color: #fff !important;
  margin: 0px 10px 0px;
}
.footerLeft > p:nth-child(4) > a:hover,
.footerLeft > p:nth-child(5) > a:hover {
  text-decoration: underline;
}
.footerLeft > p:nth-child(4) > a:first-of-type {
  margin: 0 10px 0 0;
}
.footerLeft > div {
  font-size: 1.875rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.footerLeft > p {
  margin-top: 13px;
  font-weight: 100;
}
.footerLeft > p:nth-child(4) {
  margin-top: 10px;
}
.footerLeft p,
.footerRight p {
  font-size: 0.875rem;
  font-family: PingFang SC;
  color: #ffffff;
  opacity: 0.6;
}
.footerLeft > p:first-of-type {
  margin-top: 24px;
}
.footerRight {
  display: flex;
  text-align: center;
  align-items: center;
}
.footerRight > div:last-of-type {
  margin-left: 40px;
}
.footerRight img {
  width: 114px;
  height: 114px;
}
.footerRight div > p {
  margin-top: 6px;
}
</style>
